import { useState, useEffect } from "react";

import { paths } from "src/routes/paths";

import Iconify from "src/components/iconify";
import { useAuth } from "@clerk/clerk-react";
import axios from "axios";

// ----------------------------------------------------------------------

const apiUrl = process.env.REACT_APP_API_URL;
// ----------------------------------------------------------------------

export function useNavData() {
  const { getToken } = useAuth();
  const provideToken = async () => {
    return await getToken();
  };

  const apiCallPost = async (path, datum) => {
    const token = await provideToken();
    if (!token) {
      setCurrentUser(null);
      setLoading(false);
      throw new Error("No token");
    }
    const resp = await axios.post(apiUrl + path, datum, {
      credentials: "include",
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp.data;
  };
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(null);

  const getCurrentUser = async () => {
    const response = await apiCallPost("/harley/getCurrentUser", {});
    return response;
  };

  useEffect(() => {
    setLoading(true);
    const load = async () => {
      try {
        let r = await getCurrentUser();
        setCurrentUser(r);
        setLoading(false);
      } catch (error) {
        setCurrentUser(null);
        setLoading(false);
      }
    };
    load();
  }, []);
  if (loading) return [];
  let cu = currentUser;
  if (!cu) return [];

  const data = [
    {
      subheader: "overview",
      items: [
        {
          title: "Home",
          path: paths.dashboard.root,
          icon: <Iconify icon="ci:chat-conversation-circle" />,
        },
        {
          title: "EQ",
          path: "/eq",
          icon: <Iconify icon="game-icons:abstract-111" />,
        },
      ],
    },
  ];

  if (currentUser?.hasDataExplorer) {
    data[0].items.push({
      title: "Data Explorer",
      path: "/explorer",
      icon: <Iconify icon="bxs:data" />,
    });
    data[0].items.push({
      title: "Case Notes",
      path: "/case-notes",
      icon: <Iconify icon="bi:file-earmark-medical" />,
    });
  
  }
  if (currentUser?.isAdmin) {
    data[0].items.push({
      title: "Create a bot",
      path: "/bot-create",
      icon: <Iconify icon="fluent:bot-add-24-filled" />,
    });
  }

  return data;
}
